import { Dialog, DialogTitle, DialogContent, Button, Typography, IconButton, Box, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import '../../assets/style/Payments.css';

export default function DepositConfirmModal({ open, onClose, onConfirm, data }) {
  // Если данных нет, ничего не рендерим
  if (!data) return null;

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: 'custom-dialog-paper confirm-dialog' }}  PaperProps={{
        elevation: 0,
        className: "my-custom-dialog",
      }}>
      <DialogTitle className="dialog-title-container">
        Deposit
        <IconButton onClick={onClose} className="close-button">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent className="confirm-dialog-content">
        <Typography className="confirm-main-heading">YOU ARE DEPOSITING</Typography>
        
        <Typography className="confirm-amount">
          {data.amount} $ From {data.methodName}
        </Typography>

        <Divider className="card-divider" />

        <Box className="confirm-details-section">
          <div className="info-row">
            <Typography className="info-label">Fee</Typography>
            <Typography className="info-value">{data.fee}</Typography>
          </div>
          <div className="info-row">
            <Typography className="info-label">Total Amount</Typography>
            <Typography className="info-value">{data.total}</Typography>
          </div>
        </Box>

        <Button fullWidth variant="contained" className="action-button" onClick={onConfirm}>
          Deposit
        </Button>
      </DialogContent>
    </Dialog>
  );
}